import React from 'react';
import {
  withStyles,
  makeStyles
} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const CssTextField = withStyles({
  root: {
    '& label': {
      color: 'white',
    },
    '& label.Mui-focused': {
      color: '#758184',
      // backgroundColor: '#758184',
    },
    '& .MuiOutlinedInput-root': {
      color: 'white',
      '& fieldset': {
        borderColor: 'white',
        backgroundColor: 'white',
        opacity: ".3",
      },
      '&:hover fieldset': {
        borderColor: 'yellow',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'black',
        color: 'white'
      },
    },
  },
})(TextField);

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  // input: {
  //   color: 'white',
  //   backgroundColor: 'red'
  // },
  margin: {
    margin: theme.spacing(1),
  },
}));

export default function CustomizedInputs(props) {
  const classes = useStyles();

  return (
    <div className={classes.root} noValidate>
      <CssTextField
        className={classes.margin}
        label={props.purpose}
        variant="outlined"
        name={props.name}
        id="custom-css-outlined-input"
        type={props.type || ''}
        onChange={props.handleFormChange}
        required
      />
      
    </div>
  );
}